// extracted by mini-css-extract-plugin
module.exports = {"errorPageWrapper":"errorPage_errorPageWrapper__pGeqC","errorPageHero":"errorPage_errorPageHero__eMFTA"};